const previewHelperMixin = {
    props: {
        previewIframe: {
            type: HTMLIFrameElement,
        },
    },
    methods: {
        getBlockElementById(referenceId) {
            return this.previewIframe.contentWindow.document.querySelector(`[data-block-id="${referenceId}"]`);
        },
    }
};

export default previewHelperMixin;